var React = require('react');

function Arrowright (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"}));
}

Arrowright.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Arrowright;

Arrowright.default = Arrowright;
